import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 模块列表
export const setFurBlocks: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 模块详情
export const setFurBlockDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = !!payload.loading;
};

// 模板列表
export const setFurBlockMods: Mutation<IModuleState> = (state, payload) => {
  state.blockMods.data = payload.data;
  state.blockMods.loading = !!payload.loading;
};

// 模块组装类型
export const setFurBlockStructs: Mutation<IModuleState> = (state, payload) => {
  state.blockStructs.data = payload.data;
  state.blockStructs.loading = !!payload.loading;
};

// 模块摆放轴
export const setFurBlockAxis: Mutation<IModuleState> = (state, payload) => {
  state.blockAxes.data = payload.data;
  state.blockAxes.loading = !!payload.loading;
};

// 模块状态
export const setFurBlockStatuses: Mutation<IModuleState> = (state, payload) => {
  state.blockStatuses.data = payload.data;
  state.blockStatuses.loading = !!payload.loading;
};

// 控制件组装位置
export const setFurCompLocations: Mutation<IModuleState> = (state, payload) => {
  state.compLocations.data = payload.data;
  state.compLocations.loading = !!payload.loading;
};

// 模块缩略图
export const setFurBlockThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
